import React from 'react'
import {Switch, Route, Redirect} from 'react-router-dom'

import Dashboard from './views/Dashboard/'
import Dictionary from './views/Dictionary/'
import Projects from './views/Projects/'
import Wps from './views/Wps/'
import People from './views/People/'
import Reports from './views/Reports/'
import Manual from './views/Manual/'
import Welders from './views/Welders/'
import Calculators from './views/Calculators/'
import Companies from './views/Companies/'
import {WeldabilityOfSteel, MaterialAmount} from 'weldingo-addons'
import Profile from './views/Profile/'
import {getUserPermissions} from './utils/userPermissions'

const PROTECTED_ROUTES = [
  { path: '/dashboard',   permission: 'core.dasboard.dasboard' },
  { path: '/projects',    permission: 'wl_welds.projects.index' },
  { path: '/wps',         permission: 'wl_welds.show_wps_list.show_wps_list' },
  { path: '/people',      permission: 'core.show_people_list.show_people_list' },
  { path: '/companies',   permission: 'core.companies.index' },
  { path: '/welders',     permission: 'wl_welders.show_certificates_list.show_certificates_list' },
  { path: '/reports',     permission: 'core.show_reports_list.show_reports_list' },
  { path: '/calculators', permission: null },
  { path: '/manual',      permission: null },
]

function getDefaultRedirect() {
  const first = PROTECTED_ROUTES.find(r => !r.permission || getUserPermissions(r.permission))
  return first ? first.path : '/calculators'
}

function PermissionRoute({ permission, ...props }) {
  if (permission && !getUserPermissions(permission)) {
    const currentPath = window.location.pathname
    const routePath = props.path
    const isExactMatch = currentPath === routePath
    if (isExactMatch) return <Redirect to={getDefaultRedirect()} />
  }
  return <Route {...props} />
}

export default (
  <Switch>
    <PermissionRoute path="/dashboard"   permission="core.dasboard.dasboard"                        name="Dashboard"  component={Dashboard}/>
    <Route           path="/dictionary"                                                              name="Dictionary" component={Dictionary}/>
    <PermissionRoute path="/projects"    permission="wl_welds.projects.index"                       name="Projects"   component={Projects}/>
    <PermissionRoute path="/wps"         permission="wl_welds.show_wps_list.show_wps_list"          name="Wps"        component={Wps}/>
    <PermissionRoute path="/people"      permission="core.show_people_list.show_people_list"                      name="People"     component={People}/>
    <PermissionRoute path="/reports"     permission="core.show_reports_list.show_reports_list"      name="Reports"    component={Reports}/>
    <PermissionRoute path="/companies"   permission="core.companies.index"                          name="Companies"  component={Companies}/>
    <Route exact     path="/calculators"                                                             name="Calculators"           component={Calculators}/>
    <Route exact     path="/calculators/weldability-of-steel"                                       name="Weldability of steel"  component={WeldabilityOfSteel}/>
    <Route exact     path="/calculators/material-amount"                                            name="Material amount"       component={MaterialAmount}/>
    <Route           path="/manual"                                                                  name="Manual"     component={Manual}/>
    <PermissionRoute path="/welders"     permission="wl_welders.show_certificates_list.show_certificates_list"          name="Welders"    component={Welders}/>
    <Route           path="/profile"                                                                 name="Profile"    component={Profile}/>
    <Redirect from="/" to={getDefaultRedirect()}/>
  </Switch>
)



// WEBPACK FOOTER //
// ./src/routes.js